import { Response } from "@/types/response/Response";
import ApiUtils from "../../lib/ApiUtils";
import { createApi } from "@reduxjs/toolkit/query/react";
import { PageDTO } from "@/types/response/PageDTO";
import { SMSMessageDTO } from "@/types/message/sms/SMSMessageDTO";
import { SMSMessageFilter } from "@/types/message/sms/SMSMessageFilter";
import { MessageStatusDTO } from "@/types/message/MessageStatusDTO";
import { MessageTypeDTO } from "@/types/message/MessageTypeDTO";

export const messageApiV1 = createApi({
  reducerPath: "_message",
  baseQuery: ApiUtils.apiQuery("/v1"),
  tagTypes: ["_messages", "_messages_status_list", "_messages_type_list"],
  endpoints: (builder) => ({
    getMessages: builder.query<
      Response<PageDTO<SMSMessageDTO>>,
      Partial<SMSMessageFilter>
    >({
      query: (body) => ({
        url: "messages",
        method: "PUT",
        body: body,
      }),
      providesTags: ["_messages"],
    }),
    getMessageStatusList: builder.query<
      Response<MessageStatusDTO[]>,
      Partial<void>
    >({
      query: () => "/messages/status-list",
      providesTags: ["_messages_status_list"],
    }),
    getMessageTypeList: builder.query<
      Response<MessageTypeDTO[]>,
      Partial<void>
    >({
      query: () => "/messages/type-list",
      providesTags: ["_messages_type_list"],
    }),
  }),
});

export const {
  useLazyGetMessagesQuery,
  useGetMessageTypeListQuery,
  useGetMessageStatusListQuery,
} = messageApiV1;
